import React, { useEffect, useState } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { LogoTicker } from '../components/LogoTicker';
import { motion } from 'framer-motion';
export function DevelopmentMigration() {
  const [activeSection, setActiveSection] = useState('shopify-development');
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Update scrolled state for header
      const isScrolled = window.scrollY > 10;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
      // Only update active section visually without affecting URL or scroll position
      const sections = document.querySelectorAll('.service-section[id]');
      sections.forEach(section => {
        const sectionTop = section.getBoundingClientRect().top;
        const sectionId = section.getAttribute('id');
        if (sectionTop < 200 && sectionTop >= -section.getBoundingClientRect().height + 200) {
          setActiveSection(sectionId);
        }
      });
    };
    window.addEventListener('scroll', handleScroll);
    // Handle initial section display only - no automatic scrolling
    const handleInitialLoad = () => {
      // Set default active section without scrolling
      setActiveSection('shopify-development');
    };
    handleInitialLoad();
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [scrolled]);
  const scrollToSection = sectionId => {
    setActiveSection(sectionId);
    // Don't update URL with hash to avoid bounce-back issues
    const element = document.getElementById(sectionId);
    if (element) {
      // Use smooth scrolling for user-initiated navigation
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <div className="min-h-screen bg-[#FAF7F2]" data-id="element-249">
      <Header data-id="element-250" />
      {/* Hero Section - Updated with proper top padding for fixed header */}
      <section className="pt-28 pb-20 px-6 md:px-10" data-id="element-251">
        <div className="max-w-[1400px] mx-auto" data-id="element-252">
          <div className="bg-white rounded-3xl shadow-xl overflow-hidden" data-id="element-253">
            <div className="grid md:grid-cols-2" data-id="element-254">
              <div className="p-6 md:p-12 lg:p-16 flex flex-col justify-center" data-id="element-255">
                <h1 className="text-[#2C2416] text-[clamp(48px,6vw,64px)] font-light leading-[1.1] tracking-[-3px] mb-6 font-['Inter']" data-id="element-256">
                  Design, Development &{' '}
                  <span className="text-[#D4A574]" data-id="element-257">Migration</span>
                </h1>
                <p className="text-[#8B7355] text-xl max-w-lg mb-10 leading-relaxed font-['Inter']" data-id="element-258">
                  Design, development, migrations, and email. 15 years of
                  ecommerce experience behind every build. We do the work, you
                  grow the brand.
                </p>
                <div className="flex flex-wrap gap-5" data-id="element-259">
                  <a href="/contact" className="bg-[#2C2416] text-[#FAF7F2] px-9 py-[18px] rounded-full font-medium tracking-[0.5px] hover:scale-105 transition-all duration-300 hover:bg-[#D4A574] font-['Inter']" data-id="element-260">
                    Get In Touch
                  </a>
                </div>
              </div>
              <div className="bg-[#FAF7F2] flex items-center justify-center min-h-[400px] md:min-h-[600px] overflow-hidden relative" data-id="element-261">
                <svg className="w-full h-full absolute inset-0" viewBox="0 0 800 1000" preserveAspectRatio="xMidYMid slice" data-id="element-262">
                  <defs data-id="element-263">
                    <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="100%" data-id="element-264">
                      <stop offset="0%" style={{
                      stopColor: '#FAF7F2',
                      stopOpacity: 1
                    }} data-id="element-265" />
                      <stop offset="100%" style={{
                      stopColor: '#E8C4A0',
                      stopOpacity: 0.3
                    }} data-id="element-266" />
                    </linearGradient>
                  </defs>

                  {/* Background Pattern */}
                  <rect width="100%" height="100%" fill="url(#grad1)" data-id="element-267" />

                  {/* Abstract Composition */}
                  <g transform="translate(400, 500)" data-id="element-268">
                    {/* Central Structure */}
                    <circle cx="0" cy="0" r="250" fill="none" stroke="#D4A574" strokeWidth="1" opacity="0.2" data-id="element-269" />
                    <circle cx="0" cy="0" r="180" fill="none" stroke="#2C2416" strokeWidth="1" opacity="0.1" data-id="element-270" />

                    {/* Floating Elements representing Migration/Data */}
                    <circle cx="-100" cy="-150" r="60" fill="#2C2416" opacity="0.05" data-id="element-271" />
                    <circle cx="120" cy="100" r="90" fill="#D4A574" opacity="0.1" data-id="element-272" />

                    {/* Connecting Lines */}
                    <line x1="-200" y1="200" x2="200" y2="-200" stroke="#D4A574" strokeWidth="2" opacity="0.2" data-id="element-273" />
                    <line x1="-200" y1="-200" x2="200" y2="200" stroke="#2C2416" strokeWidth="1" opacity="0.1" data-id="element-274" />

                    {/* Architectural Shapes */}
                    <rect x="-150" y="-50" width="300" height="100" fill="none" stroke="#2C2416" strokeWidth="2" opacity="0.1" rx="50" data-id="element-275" />
                  </g>
                </svg>

                {/* Overlay Content (Optional, purely visual) */}
                <div className="relative z-10 text-center" data-id="element-276">
                  <div className="w-24 h-24 rounded-full bg-[#2C2416] flex items-center justify-center mx-auto mb-6 shadow-2xl" data-id="element-277">
                    <span className="text-[#D4A574] text-4xl" data-id="element-278">⚡</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Shopify Development */}
      <section id="shopify-development" className="service-section py-24 bg-[#FAF7F2] scroll-mt-36 px-10" data-id="element-279">
        <div className="max-w-[1400px] mx-auto" data-id="element-280">
          <div className="grid md:grid-cols-2 gap-20 items-center" data-id="element-281">
            <div data-id="element-282">
              <h2 className="text-[#2C2416] text-[clamp(36px,5vw,48px)] font-light tracking-[-2px] mb-6 font-['Inter']" data-id="element-283">
                eCommerce Development
              </h2>
              <p className="text-[#8B7355] text-lg mb-8 leading-relaxed font-['Inter']" data-id="element-284">
                Modern tools, faster iterations. We deliver design variations
                quickly so you can see options and move forward without endless
                rounds of feedback. Backed by 15 years of ecommerce experience
                across Shopify, Commerce7, WineHub, WinePik, and more.
              </p>
              <ul className="mb-10 space-y-4" data-id="element-285">
                {['Rapid design iterations', 'Multiple variations to choose from', 'Custom design for your brand', 'Full development - front and back-end', 'App setup and integrations', 'Mobile-first, ready to launch'].map((item, index) => <li key={index} className="flex items-start text-[#8B7355] font-['Inter'] pl-8 relative" data-id="element-286">
                    <span className="text-[#D4A574] absolute left-0 font-semibold" data-id="element-287">
                      ✓
                    </span>
                    {item}
                  </li>)}
              </ul>
            </div>
            <div className="bg-white rounded-2xl overflow-hidden shadow-lg" data-id="element-288">
              <div className="aspect-[4/3] relative overflow-hidden bg-[#2C2416]" data-id="element-289">
                <svg className="absolute inset-0 w-full h-full" viewBox="0 0 400 300" preserveAspectRatio="xMidYMid slice" data-id="element-290">
                  {/* Shopify Development: Abstract Construction/Grid */}
                  <defs data-id="element-291">
                    <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse" data-id="element-292">
                      <path d="M 40 0 L 0 0 0 40" fill="none" stroke="#D4A574" strokeWidth="0.5" opacity="0.1" data-id="element-293" />
                    </pattern>
                  </defs>
                  <rect width="100%" height="100%" fill="url(#grid)" data-id="element-294" />

                  {/* Central Architecture */}
                  <g transform="translate(200, 150)" data-id="element-295">
                    <rect x="-80" y="-60" width="160" height="120" stroke="#D4A574" strokeWidth="2" fill="none" data-id="element-296" />
                    <rect x="-60" y="-40" width="120" height="80" fill="#D4A574" opacity="0.1" data-id="element-297" />

                    {/* Connecting Lines */}
                    <line x1="-120" y1="0" x2="-80" y2="0" stroke="#FAF7F2" strokeWidth="1" opacity="0.3" data-id="element-298" />
                    <line x1="80" y1="0" x2="120" y2="0" stroke="#FAF7F2" strokeWidth="1" opacity="0.3" data-id="element-299" />
                    <line x1="0" y1="-90" x2="0" y2="-60" stroke="#FAF7F2" strokeWidth="1" opacity="0.3" data-id="element-300" />
                    <line x1="0" y1="60" x2="0" y2="90" stroke="#FAF7F2" strokeWidth="1" opacity="0.3" data-id="element-301" />

                    {/* Data Points */}
                    <circle cx="-120" cy="0" r="4" fill="#D4A574" data-id="element-302" />
                    <circle cx="120" cy="0" r="4" fill="#D4A574" data-id="element-303" />
                  </g>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Platform Migration */}
      <section id="platform-migration" className="service-section py-24 bg-white scroll-mt-36 px-10" data-id="element-304">
        <div className="max-w-[1400px] mx-auto" data-id="element-305">
          <div className="grid md:grid-cols-2 gap-20 items-center" data-id="element-306">
            <div className="md:order-2" data-id="element-307">
              <h2 className="text-[#2C2416] text-[clamp(36px,5vw,48px)] font-light tracking-[-2px] mb-6 font-['Inter']" data-id="element-308">
                Platform Migration Services
              </h2>
              <p className="text-[#8B7355] text-lg mb-8 leading-relaxed font-['Inter']" data-id="element-309">
                We've migrated hundreds of stores between platforms -
                WooCommerce to Shopify, legacy systems to Commerce7, and
                everything in between. Data, customers, products, all moved
                properly with nothing left behind. You end up with a better
                store, not just the same store on a new platform.
              </p>
              <ul className="mb-10 space-y-4" data-id="element-310">
                {['WooCommerce, Magento & legacy platforms', 'Shopify, Commerce7, WineHub, WinePik', 'Complete data and customer migration', 'SEO-safe URL redirects', 'Design rebuilt, not just copied', 'Zero downtime process'].map((item, index) => <li key={index} className="flex items-start text-[#8B7355] font-['Inter'] pl-8 relative" data-id="element-311">
                    <span className="text-[#D4A574] absolute left-0 font-semibold" data-id="element-312">
                      ✓
                    </span>
                    {item}
                  </li>)}
              </ul>
            </div>
            <div className="bg-white rounded-2xl overflow-hidden shadow-lg md:order-1" data-id="element-313">
              <div className="aspect-[4/3] relative overflow-hidden bg-[#FAF7F2]" data-id="element-314">
                <svg className="absolute inset-0 w-full h-full" viewBox="0 0 400 300" preserveAspectRatio="xMidYMid slice" data-id="element-315">
                  {/* Platform Migration: Flowing Data Streams */}
                  <defs data-id="element-316">
                    <linearGradient id="flowGrad" x1="0%" y1="0%" x2="100%" y2="0%" data-id="element-317">
                      <stop offset="0%" style={{
                      stopColor: '#2C2416',
                      stopOpacity: 0.1
                    }} data-id="element-318" />
                      <stop offset="50%" style={{
                      stopColor: '#D4A574',
                      stopOpacity: 0.8
                    }} data-id="element-319" />
                      <stop offset="100%" style={{
                      stopColor: '#2C2416',
                      stopOpacity: 0.1
                    }} data-id="element-320" />
                    </linearGradient>
                  </defs>

                  {/* Curved Paths */}
                  <path d="M -50 200 Q 100 200 200 100 T 450 100" stroke="url(#flowGrad)" strokeWidth="2" fill="none" data-id="element-321" />
                  <path d="M -50 220 Q 100 220 200 120 T 450 120" stroke="#2C2416" strokeWidth="1" fill="none" opacity="0.2" data-id="element-322" />
                  <path d="M -50 180 Q 100 180 200 80 T 450 80" stroke="#2C2416" strokeWidth="1" fill="none" opacity="0.2" data-id="element-323" />

                  {/* Moving Elements */}
                  <circle cx="200" cy="100" r="12" fill="#D4A574" opacity="0.2" data-id="element-324" />
                  <circle cx="200" cy="100" r="6" fill="#D4A574" data-id="element-325" />

                  <circle cx="150" cy="165" r="4" fill="#2C2416" opacity="0.4" data-id="element-326" />
                  <circle cx="250" cy="65" r="4" fill="#2C2416" opacity="0.4" data-id="element-327" />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Custom Design & UI */}
      <section id="custom-design" className="service-section py-24 bg-[#FAF7F2] scroll-mt-36 px-10" data-id="element-328">
        <div className="max-w-[1400px] mx-auto" data-id="element-329">
          <div className="grid md:grid-cols-2 gap-20 items-center" data-id="element-330">
            <div data-id="element-331">
              <h2 className="text-[#2C2416] text-[clamp(36px,5vw,48px)] font-light tracking-[-2px] mb-6 font-['Inter']" data-id="element-332">
                Email
              </h2>
              <p className="text-[#8B7355] text-lg mb-8 leading-relaxed font-['Inter']" data-id="element-333">
                Klaviyo setup and migrations done by a team that's built
                hundreds of accounts. We create flows that bring customers back
                - welcome series, abandoned cart, post-purchase, win-back -
                built around how your customers actually buy, not just
                templates.
              </p>
              <ul className="mb-10 space-y-4" data-id="element-334">
                {['Klaviyo setup and migration', 'Welcome series and onboarding flows', 'Abandoned cart and browse abandonment', 'Post-purchase and repeat buyer flows', 'Win-back and re-engagement', 'Strategy based on your customer behaviour'].map((item, index) => <li key={index} className="flex items-start text-[#8B7355] font-['Inter'] pl-8 relative" data-id="element-335">
                    <span className="text-[#D4A574] absolute left-0 font-semibold" data-id="element-336">
                      ✓
                    </span>
                    {item}
                  </li>)}
              </ul>
            </div>
            <div className="bg-white rounded-2xl overflow-hidden shadow-lg" data-id="element-337">
              <div className="aspect-[4/3] relative overflow-hidden bg-[#2C2416]" data-id="element-338">
                <svg className="absolute inset-0 w-full h-full" viewBox="0 0 400 300" preserveAspectRatio="xMidYMid slice" data-id="element-339">
                  {/* Email: Outreach and Connection */}
                  <g transform="translate(200, 150)" data-id="element-340">
                    {/* Ripples */}
                    <circle cx="0" cy="0" r="30" stroke="#D4A574" strokeWidth="2" fill="none" data-id="element-341" />
                    <circle cx="0" cy="0" r="60" stroke="#D4A574" strokeWidth="1" fill="none" opacity="0.4" data-id="element-342" />
                    <circle cx="0" cy="0" r="90" stroke="#D4A574" strokeWidth="0.5" fill="none" opacity="0.2" data-id="element-343" />
                    <circle cx="0" cy="0" r="120" stroke="#D4A574" strokeWidth="0.25" fill="none" opacity="0.1" data-id="element-344" />

                    {/* Nodes */}
                    <line x1="0" y1="0" x2="80" y2="-80" stroke="#FAF7F2" strokeWidth="1" opacity="0.3" data-id="element-345" />
                    <circle cx="80" cy="-80" r="4" fill="#FAF7F2" opacity="0.6" data-id="element-346" />

                    <line x1="0" y1="0" x2="-90" y2="40" stroke="#FAF7F2" strokeWidth="1" opacity="0.3" data-id="element-347" />
                    <circle cx="-90" cy="40" r="4" fill="#FAF7F2" opacity="0.6" data-id="element-348" />

                    <line x1="0" y1="0" x2="60" y2="90" stroke="#FAF7F2" strokeWidth="1" opacity="0.3" data-id="element-349" />
                    <circle cx="60" cy="90" r="4" fill="#FAF7F2" opacity="0.6" data-id="element-350" />
                  </g>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* App Ecosystem */}
      <section id="app-ecosystem" className="service-section py-24 bg-white scroll-mt-36 px-10" data-id="element-351">
        <div className="max-w-[1400px] mx-auto" data-id="element-352">
          <div className="grid md:grid-cols-2 gap-20 items-center" data-id="element-353">
            <div className="md:order-2" data-id="element-354">
              <h2 className="text-[#2C2416] text-[clamp(36px,5vw,48px)] font-light tracking-[-2px] mb-6 font-['Inter']" data-id="element-355">
                Support
              </h2>
              <p className="text-[#8B7355] text-lg mb-8 leading-relaxed font-['Inter']" data-id="element-356">
                We stick around after launch. Ongoing help when you need it -
                updates, fixes, advice, improvements. You don't have to explain
                your store from scratch every time something needs doing. We're
                already across it.
              </p>
              <ul className="mb-10 space-y-4" data-id="element-357">
                {['Ongoing retainer support', 'Updates and maintenance', 'Bug fixes and troubleshooting', 'New features and improvements', 'Advice when you need it', 'Long-term partnership, not a ticket queue'].map((item, index) => <li key={index} className="flex items-start text-[#8B7355] font-['Inter'] pl-8 relative" data-id="element-358">
                    <span className="text-[#D4A574] absolute left-0 font-semibold" data-id="element-359">
                      ✓
                    </span>
                    {item}
                  </li>)}
              </ul>
            </div>
            <div className="bg-white rounded-2xl overflow-hidden shadow-lg md:order-1" data-id="element-360">
              <div className="aspect-[4/3] relative overflow-hidden bg-[#FAF7F2]" data-id="element-361">
                <svg className="absolute inset-0 w-full h-full" viewBox="0 0 400 300" preserveAspectRatio="xMidYMid slice" data-id="element-362">
                  {/* Support: Stability and Structure */}
                  <g transform="translate(200, 150)" data-id="element-363">
                    {/* Interlocking Shapes */}
                    <rect x="-60" y="-80" width="120" height="160" stroke="#2C2416" strokeWidth="2" fill="none" data-id="element-364" />
                    <rect x="-40" y="-60" width="80" height="120" fill="#D4A574" opacity="0.15" data-id="element-365" />

                    {/* Cross Bracing */}
                    <line x1="-60" y1="-80" x2="60" y2="80" stroke="#D4A574" strokeWidth="1" opacity="0.4" data-id="element-366" />
                    <line x1="60" y1="-80" x2="-60" y2="80" stroke="#D4A574" strokeWidth="1" opacity="0.4" data-id="element-367" />

                    {/* Foundation */}
                    <rect x="-80" y="80" width="160" height="10" fill="#2C2416" data-id="element-368" />

                    {/* Floating Elements */}
                    <circle cx="0" cy="-100" r="6" fill="#D4A574" data-id="element-369" />
                    <circle cx="90" cy="0" r="4" fill="#2C2416" opacity="0.3" data-id="element-370" />
                    <circle cx="-90" cy="0" r="4" fill="#2C2416" opacity="0.3" data-id="element-371" />
                  </g>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Features Grid - Updated to match HTML */}
      <section className="py-24 bg-white px-10" data-id="element-372">
        <div className="max-w-[1400px] mx-auto" data-id="element-373">
          <div className="text-center mb-20" data-id="element-374">
            <h2 className="text-[#2C2416] text-[clamp(36px,5vw,48px)] font-light tracking-[-2px] mb-5 font-['Inter']" data-id="element-375">
              Why Work With Us
            </h2>
            <p className="text-[#8B7355] text-lg font-['Inter']" data-id="element-376">
              What you get when we're your implementation team
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-377">
            {[{
            title: '15 Years Experience',
            description: "Hundreds of stores built across Shopify, Commerce7, WineHub, WinePik, and more. We've seen what works and what doesn't."
          }, {
            title: 'Faster Design Iterations',
            description: 'Modern tools mean more variations, quicker decisions, and lower design costs. No endless back-and-forth.'
          }, {
            title: 'We Stick Around',
            description: "Long-term partnerships, not handoffs. Our clients stay with us because we're already across their store when something needs doing."
          }, {
            title: 'Platform Agnostic',
            description: "We recommend what fits your business, not what's easiest for us. Honest advice on the right platform for you."
          }, {
            title: 'Migration Specialists',
            description: 'WooCommerce, Magento, legacy systems - moved to Shopify, Commerce7, or wherever makes sense. Done properly, nothing left behind.'
          }, {
            title: 'No Templates',
            description: 'Custom design for your brand. Every store built specifically for you, not pulled from a library.'
          }].map((feature, index) => <motion.div key={index} className="bg-[#FAF7F2] p-8 rounded-xl border border-[#D4A57420] transition-all duration-300 hover:shadow-xl hover:-translate-y-1" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} data-id="element-378">
                <h4 className="text-[#2C2416] text-xl font-medium mb-4 font-['Inter']" data-id="element-379">
                  {feature.title}
                </h4>
                <p className="text-[#8B7355] font-['Inter'] text-[15px] leading-relaxed" data-id="element-380">
                  {feature.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </section>
      {/* Logo Ticker - Seamless with white background */}
      <LogoTicker data-id="element-381" />
      {/* CTA Section - Updated to match HTML */}
      <section className="py-20 px-6 md:px-10" data-id="element-382">
        <div className="max-w-[1400px] mx-auto" data-id="element-383">
          <div className="bg-[#2C2416] text-center p-8 md:p-16 lg:p-24 rounded-3xl" data-id="element-384">
            <h2 className="text-[#FAF7F2] text-[clamp(36px,5vw,48px)] font-light tracking-[-2px] mb-4 md:mb-6 font-['Inter']" data-id="element-385">
              Let's Build Something
            </h2>
            <p className="text-[#D4A574] text-lg md:text-xl max-w-2xl mx-auto mb-8 md:mb-12 font-['Inter'] leading-relaxed" data-id="element-386">
              Tell us about your project. New store, migration, email setup, or
              ongoing support - we'll take it from there.
            </p>
            <div className="flex flex-wrap justify-center gap-5" data-id="element-387">
              <a href="/contact" className="bg-[#D4A574] text-[#2C2416] px-9 py-[18px] rounded-full font-medium tracking-[0.5px] hover:scale-105 transition-all duration-300 hover:bg-[#FAF7F2] font-['Inter']" data-id="element-388">
                Start Your Project
              </a>
            </div>
          </div>
        </div>
      </section>
      <Footer data-id="element-389" />
    </div>;
}